// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as LinksStore$PorterinFeature from "../../domain/repo/LinksStore.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";

function LogoComponent(Props) {
  var citySelectedContext = Props.citySelectedContext;
  var logo = Props.logo;
  var isDesktop = Props.isDesktop;
  var match = Router.useRouter();
  var locale = match.locale;
  var redirectionLink = function (param) {
    if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
      return LinksStore$PorterinFeature.ban.target;
    } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
      return LinksStore$PorterinFeature.home_page_link.target;
    } else if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.tr_TR) {
      return LinksStore$PorterinFeature.tur.target;
    } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
      return LinksStore$PorterinFeature.home_page_link.target;
    } else {
      return "/";
    }
  };
  return React.createElement("a", {
              href: redirectionLink(undefined) + citySelectedContext.query_params,
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, HomeStoreEn$PorterinFeature.ga_header_home_action, undefined);
                })
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: logo.path,
                  height: isDesktop ? 18.0 : 15.0,
                  width: isDesktop ? 91.8 : 76.5,
                  quality: 100.0,
                  alt: logo.alt_text
                }));
}

var make = LogoComponent;

export {
  make ,
}
/* react Not a pure module */
